'use client'

// Client-Variante der App-Erkennung aus lib/app-erkennung.ts.
//
// Gebraucht fuer Bausteine ausserhalb von app/(hub)/layout.tsx, die dessen
// CSS-Variablen (--app-leiste, --fuss-safe) nicht erben — allen voran der
// CookieBanner, der im Wurzel-Layout haengt.
//
// Nur fuer Darstellung verwenden, nie fuer Berechtigungen: Der User-Agent
// laesst sich beliebig faelschen.

import { useEffect, useState } from 'react'

export function useIstApp(): boolean {
  // Startwert identisch zum Server-Render, der echte Wert kommt im Effect.
  const [inApp, setInApp] = useState(false)

  useEffect(() => {
    setInApp(navigator.userAgent.includes('DJAllianzApp'))
  }, [])

  return inApp
}
